export default __webpack_public_path__ + "static/alloy26-112ccbf3e6fa037ea25af2fe95680ad1.webp";